import React, { useContext, useState } from 'react';

import { showSnackbar } from 'helpers/snackbar';

import { media } from 'context';
import { Icon, IconButton, Layout, Text } from 'ds';
import { Feedback } from 'shared/types';
import { actions } from 'store/AIAssistant';
import { useAppDispatch } from 'store/hooks';

import { addWorkOrderFeedback } from './requests';

interface Props {
  supportTicketId: number;
  workOrderId: number;
  userFeedback?: Feedback;
}

const SupportTicketWorkOrderPageFeedbackCard: React.FC<Props> = ({ supportTicketId, workOrderId, userFeedback }) => {
  const { isMobile } = useContext(media);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const dispatch = useAppDispatch();
  const thumbClicked = ({ workOrderId, liked }: { workOrderId: number; liked: boolean }) => {
    if (userFeedback !== undefined) return;
    setRequestInProgress(true);

    addWorkOrderFeedback({ supportTicketId, workOrderId, liked })
      .then(({ data: updatedWorkOrder }) => {
        dispatch(actions.updateSupportTicketWorkOrder({ supportTicketId, workOrder: updatedWorkOrder }));
      })
      .catch(_error => {
        showSnackbar({ message: 'An error occurred.', negative: true });
      })
      .finally(() => {
        setRequestInProgress(false);
      });
  };
  return (
    <Layout
      width={isMobile ? '100%' : 724}
      direction="row"
      justify="space-between"
      borderWidth={2}
      borderRadius={16}
      paddingX={24}
      paddingY={16}
      color="white"
      gap={isMobile ? 48 : undefined}
    >
      <Layout direction="column" gap={8}>
        <Text size={isMobile ? 'body-sm' : 'headline-xs'} color="blue-600" semibold>
          {userFeedback ? 'Thanks for the feedback!' : 'How’d it go?'}
        </Text>
        <Text size={isMobile ? 'body-xs' : 'body-sm'} color="gray-700">
          {userFeedback ? 'We appreciate you taking the time.' : 'Share your feedback to help us improve.'}
        </Text>
      </Layout>

      {userFeedback === undefined ? (
        <Layout direction="row" align="center" gap={16}>
          <IconButton
            size="lg"
            type="gray"
            name="thumbsDown"
            onClick={() => thumbClicked({ workOrderId, liked: false })}
            disabled={requestInProgress}
          />
          <IconButton
            size="lg"
            type="gray"
            name="thumbsUp"
            onClick={() => thumbClicked({ workOrderId, liked: true })}
            disabled={requestInProgress}
          />
        </Layout>
      ) : (
        <Layout direction="row" align="center" gap={8}>
          <Text size="body-md" color="gray-700" wrap={false}>
            You rated as
          </Text>
          <Icon name={userFeedback.liked ? 'thumbsUpFilled' : 'thumbsDownFilled'} size="xs" color="gray-700" />
        </Layout>
      )}
    </Layout>
  );
};

export default SupportTicketWorkOrderPageFeedbackCard;
